// src/redux/actions/countryActions.js
import axios from "axios";
import { COUNTRY_ACTIONS as TYPES } from "../../actions/chatbotActions/chatbotActionTypes";
import { apicall } from "../../../services/api";
import { toast } from "react-hot-toast";

const BASE_URL = "chatbot/country";

// Fetch all countries
export const fetchCountries = (update = false) => async (dispatch, getState) => {
  dispatch({ type: TYPES.FETCH_REQUEST });
  if (update) {
    if (getState().countryReducer?.countries?.data?.length > 0) {
      dispatch({ type: TYPES.FETCH_SUCCESS, payload: getState().countryReducer?.countries });
      return;
    }
  }


  try {
    const res = await apicall(`${BASE_URL}/`, "get", {}, {}, "v3");
    dispatch({ type: TYPES.FETCH_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: TYPES.FETCH_FAILURE, payload: err.message });
  }
};

// Fetch country by ID
export const fetchCountryById = (id) => async (dispatch) => {
  dispatch({ type: TYPES.FETCH_BY_ID_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/${id}`, "get", {}, {}, "v3");
    dispatch({ type: TYPES.FETCH_BY_ID_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: TYPES.FETCH_BY_ID_FAILURE, payload: err.message });
  }
};

// Add new country
export const addCountry = (data) => async (dispatch) => {
  dispatch({ type: TYPES.ADD_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/`, "post", data, {}, "v3");
    toast.success(res?.data?.message);
    dispatch(fetchCountries(false));
    dispatch({ type: TYPES.ADD_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: TYPES.ADD_FAILURE, payload: err.message });
  }
};

// Update country
export const updateCountry = (id, data) => async (dispatch) => {
  dispatch({ type: TYPES.UPDATE_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/${id}`, "patch", data, {}, "v3");
    dispatch(fetchCountries(false));
    toast.success(res?.data?.message);
    dispatch({ type: TYPES.UPDATE_SUCCESS, payload: res.data });
  } catch (err) {
    toast.error(err.message || "Failed to update country");
    dispatch({ type: TYPES.UPDATE_FAILURE, payload: err.message });
  }
};

// Delete country
export const deleteCountry = (id) => async (dispatch) => {
  dispatch({ type: TYPES.DELETE_REQUEST });
  try {
    await apicall(`${BASE_URL}/${id}`, "delete", {}, {}, "v3");
    toast.success("Country deleted successfully");
    dispatch(fetchCountries(false));
    dispatch({ type: TYPES.DELETE_SUCCESS, payload: id });
  } catch (err) {
    dispatch({ type: TYPES.DELETE_FAILURE, payload: err.message });
  }
};
